import React from 'react';
import {
  AntDesign,
  MaterialIcons,
  Ionicons,
  FontAwesome,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from '@expo/vector-icons';

export type IconFamily =
  | 'antdesign'
  | 'material'
  | 'ionicons'
  | 'fontawesome'
  | 'feather'
  | 'entypo'
  | 'materialcommunity';

export interface IconProps {
  name: string;
  family?: IconFamily;
  size?: number;
  color?: string;
  testID?: string;
  style?: any;
  // Additional props for compatibility
  alignSelf?: string;
  marginRight?: number | string;
  marginBottom?: number | string;
  marginTop?: number | string;
  marginLeft?: number | string;
  marginX?: number | string;
  marginY?: number | string;
  margin?: number | string;
  padding?: number | string;
  paddingX?: number | string;
  paddingY?: number | string;
  paddingTop?: number | string;
  paddingBottom?: number | string;
  paddingLeft?: number | string;
  paddingRight?: number | string;
  flex?: number;
  flexDirection?: string;
  alignItems?: string;
  justifyContent?: string;
}

const Icon: React.FC<IconProps> = ({
  name,
  family = 'antdesign',
  size = 24,
  color = '#000',
  testID,
  style,
  // Extract margin/padding props for style object
  alignSelf,
  marginRight,
  marginBottom,
  marginTop,
  marginLeft,
  marginX,
  marginY,
  margin,
  padding,
  paddingX,
  paddingY,
  paddingTop,
  paddingBottom,
  paddingLeft,
  paddingRight,
  flex,
  flexDirection,
  alignItems,
  justifyContent,
  ...otherProps
}) => {
  // Combine all style-related props into a single style object
  const combinedStyle = {
    ...style,
    ...(alignSelf && { alignSelf }),
    ...(marginRight !== undefined && { marginRight }),
    ...(marginBottom !== undefined && { marginBottom }),
    ...(marginTop !== undefined && { marginTop }),
    ...(marginLeft !== undefined && { marginLeft }),
    ...(marginX !== undefined && { marginHorizontal: marginX }),
    ...(marginY !== undefined && { marginVertical: marginY }),
    ...(margin !== undefined && { margin }),
    ...(padding !== undefined && { padding }),
    ...(paddingX !== undefined && { paddingHorizontal: paddingX }),
    ...(paddingY !== undefined && { paddingVertical: paddingY }),
    ...(paddingTop !== undefined && { paddingTop }),
    ...(paddingBottom !== undefined && { paddingBottom }),
    ...(paddingLeft !== undefined && { paddingLeft }),
    ...(paddingRight !== undefined && { paddingRight }),
    ...(flex !== undefined && { flex }),
    ...(flexDirection && { flexDirection }),
    ...(alignItems && { alignItems }),
    ...(justifyContent && { justifyContent }),
  };

  const iconProps = {
    name,
    size,
    color,
    testID,
    style: combinedStyle,
    ...otherProps,
  };

  switch (family) {
    case 'antdesign':
      return <AntDesign {...iconProps} />;
    case 'material':
      return <MaterialIcons {...iconProps} />;
    case 'ionicons':
      return <Ionicons {...iconProps} />;
    case 'fontawesome':
      return <FontAwesome {...iconProps} />;
    case 'feather':
      return <Feather {...iconProps} />;
    case 'entypo':
      return <Entypo {...iconProps} />;
    case 'materialcommunity':
      return <MaterialCommunityIcons {...iconProps} />;
    default:
      return <AntDesign {...iconProps} />;
  }
};

export default Icon;
